import { requestApi } from "../api/client.js";
import { ApiError } from "../api/errors.js";

export function changePassword(input: {
  current_password: string;
  new_password: string;
}): Promise<void> {
  return requestApi("/me/password", {
    body: JSON.stringify(input),
    method: "PUT",
  });
}

// DELETE /me (RDY-BE-32). The password is the proof, from any session;
// an account without one (Google or Apple) sends none. Every session ends on
// success, so a 401 that isn't about the password means it already went.
export async function deleteAccount(password: string): Promise<void> {
  try {
    await requestApi("/me", {
      body: JSON.stringify(password ? { password } : {}),
      headers: { "Idempotency-Key": crypto.randomUUID() },
      method: "DELETE",
    });
  } catch (error) {
    if (
      error instanceof ApiError &&
      error.status === 401 &&
      error.field !== "password"
    )
      return;
    throw error;
  }
}
